import React from "react";
// import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

function Contact() {

  // useEffect(()=>{
  //   document.title = 'Elixir | Contact Us';
  // }, []);

  return (
    <>
    <section className="innerPages">
      <Container>
        <div className="">
          <Row data-aos="fade-up" data-aos-duration="3000">
            <Col lg={3}>
              <div className="innerPages-box1">
                <h1>Elixir & AR <span>Contact Us</span></h1>
                <h4>Have a project in mind ? We’d Love to hear from you.</h4>
              </div>
            </Col>
            <Col lg={6}>
              <div className="innerPages-box2">
                <div className="contactForm-address">                  
                  <Row>
                    <h4>Address</h4>
                    <Col md={6}>
                      <h5>SAUDI ARABIA</h5>
                      <p>P.O.Box:2834, Al Khobar 31952,</p>
                      <p>Khobar 31463, Saudi Arabia.</p>
                      <p><span>Mobile:</span> <a href="tel:+966552301809">+966 55 230 1809</a></p>                      
                    </Col>
                    <Col md={6}>
                      <h5>INDIA</h5>
                      <p>139 A, Velachery Road,</p>
                      <p>Little Mount, Chennai - 600016.</p>
                      <p><span>Mobile:</span> <a href="tel:+916385110628">+91 63851 10628</a></p>                      
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={12}>
                      <h4 className="mt-2">Mail</h4>
                      <p><span>Enquiry:</span> <a href="mailto:Anand@elixirworldwide.com">anand@elixirworldwide.com</a></p>
                      <p><span>Mail:</span> <a href="mailto:elixirworldwide@gmail.com">elixirworldwide@gmail.com</a></p>
                      <p><span>Job:</span> <a href="mailto:jobs@elixirworldwide.com">jobs@elixirworldwide.com</a></p>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
            <Col lg={3}> 
              <div className="innerPages-box3">      
                <div className="logoPart">
                  <h5><span>"</span>A Complete Communication Solutions<span>"</span></h5>       
                </div>
              </div>     
            </Col>
          </Row>
        </div>
        <div className="">
          <Row data-aos="fade-up" data-aos-duration="3000">
            <Col lg={3}>
              <div className="innerPages-box4">   
                <div className="contactMap-text">
                  <h3>Get in Touch</h3>
                  <p>We’d love to hear from you! Whether you have questions, project inquiries, or business opportunities, our team at Elixir & AR Graphics is ready to assist. Reach out to us via phone, email, or our online form, and we’ll ensure a prompt and helpful response.</p>
                </div>  
              </div>
            </Col>
            <Col lg={9}>            
            <div className="innerPages-box5">     
              <div className="contactMap">
                <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3577.6009104706186!2d50.208681275417725!3d26.27461297703332!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjbCsDE2JzI4LjYiTiA1MMKwMTInNDAuNSJF!5e0!3m2!1sen!2sin!4v1751011781351!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
              </div>
            </div>
            </Col>
          </Row>
        </div>
      </Container>            
    </section>
    </>
  );
}

export default Contact;
